import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FeaturePreviewLightbox from '../components/FeaturePreviewLightbox';
import { featurePillars } from '../content/features';
import { trackNav } from '../lib/tagitTrack';

export default function FeaturesPage() {
  return (
    <div className="app features-page">
      <Header />
      <main>
        <section className="section section--surface-light features-hero">
          <div className="container">
            <div className="features-hero-copy">
              <div className="features-eyebrow">Knotiv features</div>
              <h1>Build better agents with evidence.</h1>
              <p className="lead">
                Knotiv brings governed creation, trusted measurement, and deliberate improvement into one operating layer.
              </p>
            </div>
          </div>
        </section>

        <nav className="features-anchor-nav" aria-label="Feature areas">
          <div className="container features-anchor-nav-inner">
            {featurePillars.map((pillar) => (
              <a key={pillar.id} href={`#${pillar.id}`} onClick={() => trackNav(`features#${pillar.id}`)}>
                {pillar.eyebrow}
              </a>
            ))}
          </div>
        </nav>

        {featurePillars.map((pillar, index) => (
          <section
            id={pillar.id}
            className={`section feature-detail-section ${index % 2 === 0 ? 'section--surface-dark' : 'section--surface-light'}`}
            key={pillar.id}
          >
            <div className={`container feature-detail ${index % 2 === 1 ? 'feature-detail--reverse' : ''}`}>
              <div className="feature-detail-copy">
                <div className="feature-detail-eyebrow">{pillar.eyebrow}</div>
                <h2>{pillar.title}</h2>
                <p>{pillar.detail}</p>
                <ul className="feature-capabilities">
                  {pillar.capabilities.map((capability) => (
                    <li key={capability}>{capability}</li>
                  ))}
                </ul>
              </div>
              <div className="feature-detail-visual">
                <FeaturePreviewLightbox
                  className="feature-detail-visual__trigger"
                  image={pillar.image}
                  alt={pillar.imageAlt}
                />
              </div>
            </div>
          </section>
        ))}

        <section className="section section--surface-dark section-cta">
          <div className="container">
            <div className="mini-cta">
              <div>
                <div className="mini-cta-title">See how Knotiv can improve your agents.</div>
                <div className="mini-cta-body">Start with the evidence your team already has.</div>
              </div>
              <Link className="btn btn-primary" to="/#inquiry">
                Talk to us
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
